<template>
  <span>
    <img
      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQos52UGiHAYF0z9_4OtnlceYdmwlTFkNWN_g&usqp=CAU"
      alt="avatar"
      style="width: 100%; border-radius: 5px;"
    />
  </span>
</template>
<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
